/* eslint-disable no-useless-escape */
import styled, { css } from 'styled-components';
import { COLORS } from '../../constants/style/color';
import { rem } from '../../utils/style';

interface TableStyles {
  border?: string;
  padding?: string | number;
}

interface TableContainerType extends TableStyles {
  height: number | string;
  overflowY?: boolean;
}

export const TableWrapper = styled.div<TableStyles>`
  background: ${COLORS.White};
  border-radius: ${rem(6)};

  ${(props) => {
    return css`
      border: ${props?.border !== undefined
        ? props.border
        : `${rem(1)} solid ${COLORS.CulturedWhite}`};
    `;
  }}

  &.report-table--wrapper .columns-space {
    margin-bottom: ${rem(3)};
  }

  &.report-table--wrapper .columns-space-header {
    margin-bottom: ${rem(33)};
  }
`;

export const TableTopContainer = styled.div`
  padding: ${rem(6)} ${rem(6)} 0 ${rem(6)};
  display: flex;
  gap: ${rem(8)};
  align-items: center;
`;

export const TableContainer = styled.div<TableContainerType>`
  background-color: ${COLORS.White};
  overflow-x: auto;
  overflow-y: auto;
  border-radius: 0.6rem;

  ${(props) => {
    return css`
      max-height: ${props?.height != null ? `${props.height}` : `${rem(500)}`};
      padding: ${props?.padding !== undefined ? props.padding : `${rem(0)} ${rem(32)}`};
    `;
  }}

  ::-webkit-scrollbar {
    height: 5px;
    width: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 7px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: ${COLORS.SpanishGray};
    border-radius: 7px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const TableStyle = styled.table`
  border: none;
  border-collapse: separate;
  width: 100%;
  border-spacing: 0;
  border-radius: 6px;

  // tr th {
  //   // input[type='checkbox']::before {
  //   //   top: ${rem(-10)} !important;
  //   // }
  //   input[type='checkbox']::after {
  //     top: ${rem(-10)} !important;
  //   }
  // }
  // tr td {
  //   // input[type='checkbox']::before {
  //   //   top: ${rem(-10)} !important;
  //   // }
  //   input[type='checkbox']::after {
  //     top: ${rem(-10)} !important;
  //   }
  // }

  thead {
    top: 0;
    position: sticky;
    z-index: 2;
    box-shadow: 0 2px 2px -2px rgb(0 0 0 / 10%);
    tr th {
      padding: 35px 14px 27px 3px;
      font-weight: 900;
      font-size: 14px;
      line-height: 18px;
      text-align: left;
      color: ${COLORS.Gray60};
      white-space: nowrap;
      border-bottom: ${rem(1)} solid ${COLORS.CulturedWhite};

      &:last-child {
        text-align: center;
      }

      & > div {
        font-weight: 900;
      }
    }

    th.custom-header {
      padding: 0;
      cursor: auto;
      border-bottom: 0;

      .custom-header--main {
        background-color: ${COLORS.Gray};
        padding: ${rem(5)} ${rem(20)};
        border-radius: 15px;
        justify-content: center !important;
        margin: 0 ${rem(4)};

        span {
          color: ${COLORS.White};
        }
      }
    }
  }

  .subrow-header {
    box-shadow: 0 2px 2px -2px rgb(0 0 0 / 10%);

    th {
      padding: 20px 14px 20px 3px;
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
      color: ${COLORS.Silver};
      white-space: nowrap;
      /* text-align is set via inline style from col.align — do NOT hardcode here */
    }

    th.custom-header {
      padding: 0;
      cursor: auto;
      border-bottom: 0;

      .custom-header--main {
        background-color: ${COLORS.Gray};
        padding: ${rem(5)} ${rem(20)};
        border-radius: 15px;
        justify-content: center !important;
        margin: 0 ${rem(4)};

        span {
          color: ${COLORS.White};
        }
      }
    }
  }

  td,
  th {
    border: none;
  }
  th {
    background: ${COLORS.White};
    cursor: pointer;
  }

  td {
    padding: 14px 0px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #161616;
    padding-right: 14px;
    padding-left: 5px;
    white-space: nowrap;
    .hasError {
      position: relative;
      &::before {
        content: '';
        top: 0;
        left: 0;
        position: absolute;
        height: 100%;
        width: 100%;
        background-color: ${COLORS.RedLightTransparent};
      }
    }
  }

  tbody tr {
    td {
      transition: all 0.2s ease-in-out;
      border-bottom: ${rem(1)} solid ${COLORS.CulturedWhite};
    }
    &:hover {
      background-color: ${COLORS.Grey100Transparent};
    }
    td:last-child {
      text-align: center;
    }
  }

  &.bordered th,
  &.bordered td {
    border-right: 0.5px solid rgba(166, 166, 166, 0.25);

    &:last-child {
      border-right: none;
    }
  }

  &.report-table {
    thead {
      tr th {
        padding: ${rem(27)} ${rem(14)} ${rem(27)} ${rem(14)};
      }
    }

    tbody tr {
      td:last-child {
        text-align: left;
      }

      td {
        padding-left: 8px;
        white-space: nowrap;
      }
    }
  }

  &.report-table--header {
    tr:nth-child(1) th {
      padding: 0;
      border-bottom: 0;
      cursor: auto;

      .sorting-icon {
        display: none !important;
      }
    }
  }

  /* ---- V2 sub-row / group alignment ---- */

  .indent-cell {
    padding: 0 !important;
    width: 0;
    min-width: 0;
    max-width: 32px;
  }

  .subrow-header-cell {
    font-weight: 500;
    font-size: 13px;
    color: ${COLORS.Silver};
    white-space: nowrap;
    cursor: default;
  }

  tr.subrow-header th {
    cursor: default;
    background: transparent;
  }

  tr.group-row {
    td {
      border-bottom: 1px solid ${COLORS.CulturedWhite};
      font-weight: 500;
    }
    &:hover {
      background-color: #f9f7ff;
    }
  }

  tr.child-row {
    td {
      border-bottom: 1px solid ${COLORS.CulturedWhite};
      font-size: 13px;
    }
  }

  /* ---- V2 virtual scroll spacer reset ---- */

  tbody[data-virtual-spacer] {
    padding: 0;
    margin: 0;
    border: none;
  }

  tbody[data-virtual-spacer] tr {
    padding: 0;
    margin: 0;
    border: none;
    background: none !important;
  }

  tbody[data-virtual-spacer] tr td {
    padding: 0 !important;
    margin: 0;
    border: none !important;
    line-height: 0;
    font-size: 0;
    transition: none;
  }

  /* Measurement tbody wrappers: ensure no extra spacing */
  tbody[data-index] {
    padding: 0;
    margin: 0;
    border: none;
  }

  /* ---- V2 inline-edit cell containment (scoped to DynamicTableV2 only) ---- */

  &[data-table-v2] tbody td[id^='cell.'] {
    white-space: normal;
    overflow: hidden;
    max-width: 0;
  }

  &[data-table-v2] tbody td[id^='cell.'] > div {
    width: 100%;
    min-width: 0;
    overflow: hidden;
  }

  &[data-table-v2] tbody td[id^='cell.'] > div > div {
    margin-bottom: 0 !important;
    width: 100%;
    min-width: 0;
  }

  &[data-table-v2] tbody td[id^='cell.'] input,
  &[data-table-v2] tbody td[id^='cell.'] textarea {
    min-width: 0 !important;
    max-width: 100% !important;
    width: 100% !important;
    box-sizing: border-box;
  }

  &[data-table-v2] tbody td[id^='cell.'] .select-multiple,
  &[data-table-v2] tbody td[id^='cell.'] [class*='container'] {
    min-width: 0 !important;
    width: 100%;
  }

  &[data-table-v2] tbody td[id^='cell.'] .react-datepicker-wrapper,
  &[data-table-v2] tbody td[id^='cell.'] .react-datepicker__input-container {
    width: 100%;
    display: block;
  }
`;

export const TableSorting = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${rem(6)};

  span {
    font-weight: 500;
    color: ${COLORS.Silver};
  }

  .sorting-icon {
    > span {
      font-size: ${rem(20)};
      width: ${rem(8)};
      height: ${rem(8)};
      display: flex;
      align-items: center;
      justify-content: center;
      color: ${COLORS.SpanishGray};
      transition: all 0.2s linear;
      &.active {
        color: ${COLORS.Black};
      }
    }
  }
`;

export const Pagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  gap: ${rem(16)};

  padding: ${rem(26)} ${rem(32)} ${rem(24)} ${rem(32)};

  @media (min-width: 1024px) {
    flex-direction: row;
  }

  .totalItems {
    color: ${COLORS.Silver};
    line-height: ${rem(35)};
  }

  .pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 0;
    list-style: none;

    li {
      padding: ${rem(5)} ${rem(11)};
      border-radius: ${rem(6)};
      cursor: pointer;

      span {
        color: ${COLORS.Gray};
      }

      &.active,
      &:hover {
        background-color: ${COLORS.LightPurple};

        span {
          color: ${COLORS.Purple};
          font-weight: 600;
        }
      }
    }
  }

  .rowItems {
    display: flex;
    gap: ${rem(4)};
    .customSelect {
      position: relative;
      cursor: pointer;
      background-color: #f3f3f3;
      border-radius: 6rem;
      display: flex;
      align-items: center;
      height: fit-content;
      z-index: 0;
      select {
        font-size: ${rem(14)};
        line-height: ${rem(18)};
        font-weight: 500;
        -webkit-appearance: none;
        cursor: pointer;

        background-color: transparent;
        z-index: 1;
        position: relative;
        padding: ${rem(7)} ${rem(20)} ${rem(7)} ${rem(10)};
        &:focus,
        &:hover {
          outline: none;
          box-shadow: none;
        }
      }
      .material-symbols-rounded {
        position: absolute;
        right: 0px;
        top: 50%;
        transform: translateY(-50%);
        color: #595959;
      }
    }
  }

  &.heading-filter {
    padding: 0;

    .rowItems {
      .customSelect {
        background: ${COLORS.OffWhite};
        border: 1px solid ${COLORS.CulturedWhite};
        border-radius: 6px;
      }
    }
  }
`;
